<app-buttons (open)="openPanel()" [buttonsWrap]="'add'" [addbut]="addbut"></app-buttons>

<app-filter [tableName]="'complementos'"></app-filter>

<app-table [tableName]="'complementos'" (addbut)="addbut=$event"></app-table>
<app-panelcustoman
  *ngIf="customanpanel !== undefined"
  [ConfigPanel]="customanpanel"
  [mode]="'I'"
>
</app-panelcustoman>
